import { post } from '@/utils/network/axios-helper';


export interface IllustrateDetail {
    desc: string;
    general: number;
    icon: string;
    key: string;
    name: string;
    vip: number;
    // [property: string]: any;
}

export interface IVipOrderInfo {
    /**
     * desc 季卡（92天）
     */
    desc: string;
    /**
     * 右上角角标
     */
    subscript: string;
    /* 订单金额*/
    amount: number;
    /**
     * 平均每天的价格
     */

    everyday: number;
    coach_num: number;
    essay_num: number;
    id: number;
    illustrate: string;
    /**
     * 会员权益
     */
    illustrate_detail: IllustrateDetail[];
    member_desc: string;

    /**
     * 订单号
     */
    order_num: string;
    original_price: number;
    review_num: number;
}

export interface IGetVipOrder_Res {
  list: IVipOrderInfo[];

}

/**
 * 获取全量订单信息
 * @returns
 */
export const getVipOrder = () => {
  return post<IGetVipOrder_Res>('/api/student/init-pay-orders');
};

export interface IGetOrderStatus_Res {
  /**
   * 订单状态
   * 1未支付 2支付中 3支付完成
   */
  status: number;
}

/**
 * 获取当前订单状态
 */
export const getOrderStatus = (order_num: string) => {
  return post<IGetOrderStatus_Res>('/api/student/get-pay-order-status', { order_num });
};

export interface IPay_Res {
    /**
     * 支付订单号
     */
    order_num: string;
    /**
     * 支付方式：1支付宝 2微信
     */
    pay_type: number;
    /**
     * 微信回调code
     */
    wechat_code?: string;
    /**
     * 是否是app支付：1是 2否
     */
    is_app?: number;

    redirect_url?: string;
}

export interface IPay_Req {
  orderStr: string;
}

/**
 * 支付，h5获取跳转链接
 */
export const pay = (param: IPay_Res) => {
  return post<IPay_Req>('/api/student/pay', param, { headers: { 'platform': 'h5' }, });
};

export interface IGetPackagPayConfig_Res {
  /**
   * 价格
   */
  amount: number;
  /**
   * 描述
   */
  desc: string;
  /**
   * 购买后的课程有效期
   */
  end_time: number;
  /**
   * 订单号
   */
  order_num: string;

  illustrate_detail: IllustrateDetail[];
}

export const getPackagPayConfig = (id: number) => {
  return post<IGetPackagPayConfig_Res>('/api/course/get-package-pay-config', { id });
};

export interface IPayRecordItem {
   id: number;
  pay_amount: number;
  pay_goods: string;
  pay_time: number;
  pay_type: string;
}

interface IGetPayRecordList_Res {
  list: IPayRecordItem[];
}

/**
 * 获取支付记录列表
 * @param student_id 学生ID
 * @returns 支付记录列表数据
 */
export const getPayRecordList = (student_id?: number) => {
  return post<IGetPayRecordList_Res>('/api/student/get-pay-record-list', { student_id });
};
